import { atom } from "recoil";

export type CardModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  modalData: any;
};

export const cardModalState = atom<CardModalType>({
  key: "cardModal",
  default: {
    visibleConfirm: false,
    modalData: [],
  },
});
